module.exports = __webpack_public_path__ + "static/Montserrat-600-bbcd5bbb5993808a92df01a5dfef77cd.ttf";